import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/store.js";
import { routes } from "./routes";
import { mapActions } from "vuex";

// configure router
Vue.use(VueRouter);

export const router = new VueRouter({
  routes,
  store,
  mode: "history",
  base: process.env.BASE_URL, // Do not remove this.  This maintains our base URL.
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters["authentication/isLoggedIn"];
  const isLoginPage = to.name === "Login";

  if (to.meta.requiresAuth && !isAuthenticated) {
    try {
      // Restore authentication from server
      await store.dispatch("authentication/restoreContext");
      next();
    } catch (error) {
      next({ name: "Login", query: { redirect: to.fullPath } });
      return;
    }
  } else if (isAuthenticated && isLoginPage) {
    // To dashboard if authenticated
    if (to.name !== "Dashboard") {
      next({ name: "Dashboard" });
    } else {
      next(); // Stay on the dashboard
    }
  } else {
    // Otherwise, allow navigation
    next();
  }
});

export default router;
